<template>
  <section class="tables new-updated-design">
    <vue-snotify></vue-snotify>
    <form class="forms-sample" @submit.stop.prevent="onSubmit" autocomplete="off">
      <div class="row mt-5">
        <div class="col-md-12 d-flex align-items-stretch grid-margin">
          <div class="row flex-grow">
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  <h4 v-if="!this.form.id" class="card-title">Add Member</h4>
                  <h4 v-if="this.form.id" class="card-title">Update Member</h4>
                </div>
                <div class="card-body">
                  <div v-if="this.form.id" class="row align-items-center justify-content-center">
                    <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                      <b-form-group label="Practice ID:" label-cols="3" label-align="right">
                        <b-form-input name="Practice_ID" type="text" readonly v-model="form.Practice_ID"></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                      <b-form-group label="User ID:" label-cols="3" label-align="right">
                        <b-form-input name="User_ID" type="text" readonly v-model="form.User_ID"></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                  <hr v-if="this.form.id" />
                  <div class="row">
                    <div class="col-md-4 col-sm-6">
                      <div>
                        <h4 class="text-center">Member</h4>
                        <br />
                        <b-form-group label="First Name" label-for="FirstName">
                          <b-form-input type="text" id="FirstName" name="FirstName" autocomplete="FirstName"
                            placeholder="First Name" v-model="$v.form.FirstName.$model" :state="!$v.form.FirstName.$dirty ? null :
                              !$v.form.FirstName.required || $v.form.FirstName.$error ? false : null
                              " aria-describedby="input-1-live-feedback">
                          </b-form-input>
                          <b-form-invalid-feedback id="input-1-live-feedback">This is a required field.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div>
                        <b-form-group label="Last Name" label-for="LastName">
                          <b-form-input type="text" id="LastName" name="LastName" autocomplete="LastName"
                            placeholder="Last Name" v-model="$v.form.LastName.$model" :state="!$v.form.LastName.$dirty ? null :
                              !$v.form.LastName.required || $v.form.LastName.$error ? false : null
                              " aria-describedby="input-1-live-feedback">
                          </b-form-input>
                          <b-form-invalid-feedback id="input-1-live-feedback">
                            This is a required field.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>

                      <div v-if="!form.id">
                        <b-form-group id="ReferralDate" label="Referral Date" label-for="ReferralDate">
                          <b-form-input id="ReferralDate" type="date" v-model="form.ReferralDate" :required="!form.id"
                            aria-describedby="referral-date-feedback"></b-form-input>
                          <b-form-invalid-feedback id="referral-date-feedback">
                            This is a required field.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div>
                        <b-form-group label="Position" label-for="Status">
                          <b-form-select name="Status" v-model="form.Status" :options="StatusOptions" class="mb-3"
                            value-field="item" text-field="name" disabled-field="notEnabled">
                          </b-form-select>
                        </b-form-group>
                      </div>
                      <div>
                        <b-form-group label="Status" label-for="MemberStatus">
                          <b-form-select v-model="form.MemberStatus" :options="MemberStatusOptions" class="mb-3"
                            value-field="item" text-field="name" disabled-field="notEnabled">
                          </b-form-select>
                        </b-form-group>
                      </div>
                      <div>
                        <b-form-group label="Membership" label-for="MembershipID">
                          <b-form-select v-model="form.MembershipID" :options="membershipOptions" class="mb-3"
                            value-field="item" text-field="name" disabled-field="notEnabled" :state="!$v.form.MembershipID.$dirty ? null :
                              !$v.form.MembershipID.required || $v.form.MembershipID.$error ? false : null"
                            aria-describedby="membership-id-feedback">
                            <template #first>
                              <b-form-select-option :value="null" disabled>Select Membership</b-form-select-option>
                            </template>
                          </b-form-select>
                          <b-form-invalid-feedback id="membership-id-feedback">
                            This is a required field.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>


                      <div>
                        <b-form-group label="Email" label-for="Email">
                          <b-form-input type="text" id="Email" name="Email" autocomplete="Email" placeholder="Email"
                            v-model="$v.form.Email.$model" :state="!$v.form.Email.$dirty ? null :
                              !$v.form.Email.required || $v.form.Email.$error ? false : null
                              ">
                          </b-form-input>
                          <b-form-invalid-feedback id="input-1-live-feedback">This is a required field.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div>
                        <b-form-group id="Membershipdate" :label="!form.id
                          ? 'Auto Transaction Date'
                          : 'Next Billing Date'
                          " label-for="Membershipdate">
                          <b-form-input id="Membershipdate" type="date" v-model="form.MembershipDate"></b-form-input>
                          <b-form-invalid-feedback id="membership-date-feedback">
                            This is a required field.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>

                      <div>
                        <b-form-group label="Is Admin?" label-for="is_admin">
                          <b-form-select name="is_admin" v-model="form.is_admin" :options="isAdminOptions" class="mb-3"
                            value-field="item" text-field="name" disabled-field="notEnabled">
                          </b-form-select>
                        </b-form-group>
                      </div>
                      <div v-if="this.form.id">
                        <b-form-group label="Password" label-for="password">
                          <b-form-input type="text" id="password" name="password" autocomplete="password"
                            placeholder="password" v-model="form.password">
                          </b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                      <div>
                        <h4 class="text-center">Practice</h4>
                        <br />
                        <b-form-group label="Address" label-for="Address1">
                          <b-form-input type="text" id="Address1" name="Address1" autocomplete="Address1"
                            placeholder="Address" v-model="$v.form.Address1.$model" :state="!$v.form.Address1.$dirty ? null :
                              !$v.form.Address1.required || $v.form.Address1.$error ? false : null
                              " aria-describedby="input-1-live-feedback">
                          </b-form-input>
                          <b-form-invalid-feedback id="input-1-live-feedback">This is a required field.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div>
                        <b-form-group label="City" label-for="City">
                          <b-form-input type="text" id="City" name="City" autocomplete="City" placeholder="City Name"
                            v-model="$v.form.City.$model" :state="!$v.form.City.$dirty ? null :
                              !$v.form.City.required || $v.form.City.$error ? false : null
                              " aria-describedby="input-1-live-feedback">
                          </b-form-input>
                          <b-form-invalid-feedback id="input-1-live-feedback">This is a required field.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div>
                        <b-form-group label="State" label-for="StateID">
                          <b-form-select name="StateID" v-model="form.StateID" :options="StateOptions" class="mb-3"
                            value-field="item" text-field="name" disabled-field="notEnabled">
                          </b-form-select>
                        </b-form-group>
                      </div>
                      <div>
                        <b-form-group label="Zip Code" label-for="Zip Code">
                          <b-form-input type="text" id="Zip" name="Zip" autocomplete="Zip" placeholder="Zip"
                            v-model="$v.form.Zip.$model" :state="!$v.form.Zip.$dirty ? null :
                              !$v.form.Zip.required || $v.form.Zip.$error ? false : null
                              ">
                          </b-form-input>
                          <b-form-invalid-feedback id="input-1-live-feedback">This is a required field.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div>
                        <b-form-group label="Phone No" label-for="Phone1">
                          <b-form-input type="text" id="Phone1" name="Phone1" autocomplete="Phone1" placeholder="Phone"
                            v-model="form.Phone1" :state="!$v.form.Phone1.$dirty ? null :
                              !$v.form.Phone1.required || $v.form.Phone1.$error ? false : null
                              ">
                          </b-form-input>
                          <b-form-invalid-feedback id="input-1-live-feedback">This is a required field.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div>
                        <b-form-group id="MemberSince" label="Member since" label-for="MemberSince">
                          <b-form-input id="MemberSince" type="date" v-model="form.MemberSince" :readonly="isEditing"
                            :state="!$v.form.MemberSince.$dirty ? null :
                              !$v.form.MemberSince.required || $v.form.MemberSince.$error ? false : null"
                            aria-describedby="member-since-feedback"></b-form-input>
                          <b-form-invalid-feedback id="member-since-feedback">
                            This is a required field.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>

                      <div v-if="this.form.id">
                        <b-form-group label="Cell" label-for="Phone2">
                          <b-form-input type="text" id="Phone2" name="Phone2" autocomplete="Phone2" placeholder="Cell"
                            v-model="form.Phone2">
                          </b-form-input>
                        </b-form-group>
                      </div>
                      <div v-if="this.form.id">
                        <b-form-group label="Fax" label-for="Fax">
                          <b-form-input type="text" id="Fax" name="Fax" autocomplete="Fax" placeholder="Fax"
                            v-model="form.Fax">
                          </b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                      <div>
                        <h4 class="text-center">Referrals</h4>
                        <br />
                        <b-form-group label="Referred By" label-for="ReferredBy">
                          <b-form-select name="ReferredBy" v-model="form.ReferredBy" :options="ReferredByOptions"
                            class="mb-3" value-field="item" text-field="name" :disabled="ReferredByOptions.length <= 1"
                            :state="!$v.form.ReferredBy.$dirty ? null :
                              !$v.form.ReferredBy.required || $v.form.ReferredBy.$error ? false : null"
                            aria-describedby="referred-by-feedback">
                            <template #first>
                              <b-form-select-option :value="null" disabled>Select Referral By</b-form-select-option>
                            </template>
                          </b-form-select>
                          <b-form-invalid-feedback id="referred-by-feedback">
                            This is a required field.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                      <div>
                        <b-form-group label="Referral Notes" label-for="ReferralNotes">
                          <b-form-textarea id="ReferralNotes" class="textarea-referral"
                            v-model="$v.form.ReferralNotes.$model" placeholder="Enter something..." rows="3"
                            max-rows="6" :state="!$v.form.ReferralNotes.$dirty ? null :
                              !$v.form.ReferralNotes.required || $v.form.ReferralNotes.$error ? false : null
                              ">
                          </b-form-textarea>
                          <b-form-invalid-feedback id="input-1-live-feedback">This is a required field.
                          </b-form-invalid-feedback>
                        </b-form-group>
                        <!-- <div class="col-md-4"> -->
                        <div v-if="this.form.id" class="material-box bg-white team-box success-rate">
                          <div class="row content-row">
                            <div class="col-md-12 top-title">
                              <h3>Success Rates</h3>
                            </div>
                            <div class="col-md-12 p-b-15">
                              <div class="table-responsive m-b-0">
                                <table class="table table-bordered table-hover table-last-row-no-border-bottom m-b-0">
                                  <tbody>
                                    <tr v-for="(focus, index) in focuses" :key="index">
                                      <td>{{ focus.FocusName }}</td>
                                      <td>{{ focus.m_avg }}%</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6"></div>
                    <div class="col-md-6 mt-3">
                      <b-button @click="submit()" variant="success" :disabled="isDisabled"
                        class="btn float-right btn-success">
                        <span v-if="!this.form.id">Submit</span>
                        <span v-if="this.form.id">Update</span>
                      </b-button>
                      <div v-if="this.form.id" class="form-group">
                        <button @click="userLogin()" class="btn btn-success mr-1 float-right" variant="success">
                          Login
                        </button>
                      </div>
                    </div>
                  </div>
                  <!--                                </form>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Vue from "vue";
import router from ".././router"
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required, minLength, email, requiredIf, sameAs, integer } from "vuelidate/lib/validators";
import moment from 'moment'

export default {
  name: 'Users',
  mixins: [validationMixin],
  data() {
    return {
      selected: 'A',
      options: [
        { item: 'A', name: 'Malia Sing' },
        { item: 'B', name: 'Rich Casabona' },
        { item: 'D', name: 'Jon Wells', notEnabled: true },
        { item: { d: 1 }, name: 'Matthew Glynn' }
      ],
      ReferredByOptions: [],
      isAdminOptions: [
        { item: 0, name: 'NO' },
        { item: 1, name: 'YES' },
      ],
      StatusOptions: [],
      StateOptions: [],
      MemberStatusOptions: [
        { item: 'Inactive', name: 'Inactive' },
        { item: 'Active', name: 'Active' }
      ],
      membershipOptions: [],
      form: {
        id: '',
        FirstName: '',
        Address1: '',
        LastName: '',
        City: '',
        ReferralDate: '',
        ReferralNotes: '',
        Zip: '',
        Phone1: '',
        Phone2: '',
        Fax: '',
        MemberSince: '',
        MembershipDate: '',
        Email: '',
        ReferredBy: null,
        StateID: 1,
        is_admin: 0,
        Status: 'PDC',
        MembershipID: null,
        MemberStatus: 'Inactive',
      },
      PracticeID: '',
      isDisabled: false,
      readonly: true,
      isEditing: false,
      member: {},
      focuses: [],
    };
  },
  validations: {
    form: {

      FirstName: {
        required,
      },
      Email: {
        required,
      },
      Address1: {
        required,
      },
      LastName: {
        required,
      },
      City: {
        required,
      },
      Phone1: {
        required,
      },
      Zip: {
        required,
      },
      StateID: {
        required,
      },
      ReferralNotes: {
        required,
      },
      MembershipID: {
        required,
      },
      MemberSince: {
        required,
      },
      ReferredBy: {
        required,
      },


    }
  },
  watch: {
    '$route'() {
      this.form.id = this.$route.params.id;
      if (!this.form.id || this.form.id === 'undefined') {
        // Reset the form when on "Add Member" tab
        this.resetForm();
        this.readonly = false;
      } else {
        this.readonly = true;
        this.isEditing = false;
      }
      // this.callAllApis();
    },
  },
  mounted() {
    this.form.id = this.$route.params.id;

    if (this.form.id && this.form.id !== 'undefined') {
      this.readonly = true;
      this.isEditing = true;
    } else {
      this.readonly = false;
    }
    let user = JSON.parse(localStorage.getItem('userDetails'));
    this.loginUser = user;
    this.callAllApis();
  },
  methods: {
    userLogin() {
      API.userDirectLogin(
        { id: this.form.id },
        token => {
          console.log('User logged in successfully. Token:', token);

          if (token !== undefined && token.data.user !== null && token.data.user.token !== '') {
            let userDetails = {
              userID: token.data.user.UserID,
              Username: token.data.user.Username,
              FirstName: token.data.user.FirstName,
              LastName: token.data.user.LastName,
              email: token.data.user.email,
              PracticeID: token.data.user.PracticeID,
              PracticeName: token.data.user.PracticeName,
              Status: token.data.user.Status,
              MemberStatus: token.data.user.pdc_membershipstatus,
              serviceId: token.data.user.MembershipServiceID,
              password: this.form.password
            };

            localStorage.setItem('userLoginToken', token.data.token);
            localStorage.setItem('userDetails', JSON.stringify(userDetails));
            window.open(router.resolve({ name: "user_dashboard" }).href, '_blank');
          }
        },
        err => {
          console.error('Error logging in:', err);
        }
      );
    },
    callAllApis() {
      this.getReferrals();
      this.getPositions();
      this.getStates();
      this.getMemberships();
      this.editMember();
      this.getFocuses();
    },
    resetForm() {
      // Reset the form to its default state
      this.form = {
        id: '',
        FirstName: '',
        Address1: '',
        LastName: '',
        City: '',
        ReferralDate: '',
        ReferralNotes: '',
        Zip: '',
        Phone1: '',
        Phone2: '',
        MemberSince: '',
        MembershipDate: '',
        Email: '',
        ReferredBy: 0,
        password: '',
        Fax: '',
        StateID: 1,
        is_admin: 0,
        Status: 'PDC',
        MembershipID: 0,
        MemberStatus: 'Inactive',
      };
    },
    submit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.isDisabled = true;
      API.addUpdateMember(this.form,
        data => {
          this.isDisabled = false;
          if (!this.form.id) {
            if (data.status === 410) {
              this.$showNotification(data, "error")
            } else {
              this.$showNotification(data, "success");
              this.$router.push({ name: 'ViewMember' });
            }
          } else {
            if (data.status === 200) {
              this.$showNotification(data, "success");
              this.$router.push({ name: 'ViewMember' });
            } else {
              this.$showNotification({ message: 'Please try again.' }, "error")
            }
          }
        },
        err => {
          this.isDisabled = false;

          // Check if there are errors in the response
          if (err.data && err.data.errors) {
            for (let field in err.data.errors) {
              const errorMessage = err.data.errors[field][0];
              this.$showNotification({ message: errorMessage }, 'error');
            }
          } else {
            console.log(err);
            // If no specific errors are provided, show a generic error message
            this.$showNotification({ message: err.data.errors }, 'error');
          }
        }
      )
    },
    getFocuses() {
      API.getFocuses({ PracticeID: this.form.Practice_ID },
        res => {
          this.focuses = res.data.data;
          // this.m_avgs = res.data.m_avg;
        }, err => {
          console.log(err);
        });
    },
    getMember() {
      API.getMember(this.form.id,
        data => {
          // this.form.ReferralDate = data.data.ReferralDate;
          // this.form.MemberSince = data.data.MemberSince;
          // this.form.MembershipDate = data.data.MembershipDate;
        },
        err => {
        }
      )
    },
    getReferrals() {
      API.getReferrals(
        res => {
          res.data.forEach((user) => {
            this.ReferredByOptions.push({
              item: user.UserID,
              name: user.FirstName + ' ' + user.LastName,
            });
          });
        }, err => {
        })
    },
    formatDate(value, event) {
      if (value) {
        return moment(value).format('MMM dd, yyyy')
      }
    },
    // getPositions() {
    //     API.getPositions(
    //         res => {
    //             res.data.forEach((position) => {
    //                 this.StatusOptions.push({
    //                     item: position.status,
    //                     name: position.status,
    //                 });
    //             });
    //         }, err => {
    //         })
    // },
    getPositions() {
      API.getPositions(
        res => {
          // Use Object.values to get an array of values from the response data object
          const positions = Object.values(res.data);

          positions.forEach((position) => {
            // Push each position as an option to StatusOptions array
            this.StatusOptions.push({
              item: position.status,
              name: position.status,
            });
          });
        },
        err => {
          // Handle error if necessary
        }
      );
    },

    getStates() {
      API.getStates(
        res => {
          res.data.forEach((state) => {
            this.StateOptions.push({
              item: state.StateID,
              name: state.Name,
            });
          });
        }, err => {
        })
    },
    getMemberships() {
      API.getMemberships(
        res => {
          res.data.forEach((membership) => {
            this.membershipOptions.push({
              item: membership.MembershipID,
              name: membership.Membership,
            });
          });
        }, err => {
        })
    },
    editMember() {
      if (this.$route.params.user) {
        this.member = this.$route.params.user;
        this.PracticeID = this.member.PracticeID;
        this.form.Practice_ID = this.member.PracticeID;
        this.form.User_ID = this.member.UserID;
        this.form.FirstName = this.member.FirstName;
        this.form.LastName = this.member.LastName;
        this.form.Status = this.member.Status;
        this.form.MemberStatus = this.member.MemberStatus;
        this.form.MembershipID = this.member.MembershipID;
        this.form.Email = this.member.email;
        this.form.MembershipDate = this.member.MembershipDate ? moment(this.member.MembershipDate).format('YYYY-MM-DD') : null;        
        this.form.MemberSince = this.member.MemberSince ? moment(this.member.MemberSince).format('Y-MM-D') : null;
        // this.form.ReferralDate =  moment(this.member.ReferralDate).format('Y-MM-D');
        this.form.is_admin = this.member.is_admin;
        this.form.Address1 = this.member.Address1;
        this.form.City = this.member.City;
        this.form.StateID = this.member.StateID;
        this.form.Zip = this.member.Zip;
        this.form.password = this.member.password;
        this.form.Phone1 = this.member.Phone1;
        this.form.Phone2 = this.member.Phone2;
        this.form.ReferredBy = this.member.ReferredBy;
        this.form.ReferralNotes = this.member.ReferralNotes;
        this.form.Fax = this.member.Fax;
        this.form.id = this.member.UserID;
        // this.form.ReferralDate = this.member.ReferralDate;
        // this.getMember();
        console.log('Formatted Membership Date:', this.form.MembershipDate);

      }
    },
  }, computed: {},
}
</script>